import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { RouteCMRController } from '@shared/src/controllers/route/cmr/routecmr.controller';
import { SaveECMREventDto } from '@shared/src/dtos/route/cmr/SaveECMREventDto';
import { CMREventTypes } from '@shared/src/enums/CMREventTypes';
import { HString } from '@shared/src/public-api';

@Component({
  selector: 'addeventdialog-dialog',
  templateUrl: './addeventdialog.dialog.component.html'
})
export class AddEventDialogDialogComponent {

  @Output() public onResolve: EventEmitter<boolean> = new EventEmitter<boolean>();

  public pendingSave: boolean = false;

  private _event: string = "";
  get event(): string {
    return this._event;
  }
  set event(value: string) {
    if (this._event === value)
      return;
    this._event = value;
    this.pendingSave = !HString.isNullOrNullString(value);
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private mdDialogRef: MatDialogRef<AddEventDialogDialogComponent>,
    private mdDialog: MatDialog,
    private ecmrController: RouteCMRController,
    private openEcmrController: OpenRouteCMRController) { }

  onClose() {
    this.onResolve.next(false);
    this.mdDialog.closeAll();
  }

  onConfirm() {
    if (HString.isNullOrNullString(this.event))
      return;

    const dto = SaveECMREventDto.build(this.data.routePartCMRId, this.event, CMREventTypes.Generic);

    if(!this.data.external){
      this.ecmrController.saveECMREvent(dto).subscribe(e => {
        if (e) {
          this.onResolve.next(true);
          this.mdDialog.closeAll();
        }
      });
    }else{
      this.openEcmrController.saveECMREvent(dto).subscribe(e => {
        if (e) {
          this.onResolve.next(true);
          this.mdDialog.closeAll();
        }
      });
    }
  }
}
